window.WEB_URL=process.env.NODE_ENV != 'production'?"https://care.starice.com.cn":"https://care.starice.com.cn";
window.UPLOAD_URL = WEB_URL+"/upload"



//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = 5N5f
// module chunks = 42